import React from 'react';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import PropTypes from 'prop-types';

import PersonBody from './PersonBody';
import PersonData from './PersonData';

const PersonEdit = (props) => {
  const { data, properties, block, selected } = props;

  return (
    <>
      <PersonBody
        content={properties}
        layout={data?.layout}
        summary={data?.summary}
        showDescription={data?.showDescription}
        hideName={data?.hideName}
        showPersonLink={data?.showPersonLink}
        isEditMode
      />
      <SidebarPortal selected={selected}>
        <PersonData key={block} {...props} data={data} block={block} />
      </SidebarPortal>
    </>
  );
};

PersonEdit.propTypes = {
  data: PropTypes.object,
  properties: PropTypes.object,
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
  selected: PropTypes.bool,
};

export default PersonEdit;
